module.exports = __webpack_public_path__ + "static/kanu-86e85e7593f982ea32541ddf611c934d.png";